import { createGlobalStyle } from "styled-components";
import { colors } from "../../colors";

const GlobalStyles = createGlobalStyle`

*{
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: 'Space Grotesk', sans-serif;
}

body {
  background: ${colors.body_color};
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  /* line-height: 1.75; */
  color: ${colors.body_text};
}

p {
  font-size: 1.6rem;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
}

h1 {
  margin-top: 0;
  font-family: 'Space Grotesk', sans-serif;
  font-size: 3.2rem;
  font-weight: 400;
  line-height: 53.792px;
}

h2 {
  font-size: 2.441rem;
  line-height: 41.0164px;
}

h3 {
    font-family: 'Space Grotesk', sans-serif;
    font-size: 2rem;
    font-weight: 600;
    line-height: 31.468px;
    /* color: ${colors.white}; */
}

h4 {
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 26.896px;
}

h5 {
  font-size: 1.4rem;
  line-height: 22.324px;
}

h6 {
    font-size: 1.072rem;
    font-family: 'Inter', sans-serif;
    line-height: 18.02;
}

small {
    font-family: 'Poppins', sans-serif;
    font-size: 1rem;
    line-height: 21px;
    color: ${colors.faint_text};
}

a {
    text-decoration: none;
}

ul {
    list-style-type: none;
    padding: 0;
}

input {
  background-color: #fff !important;
}

br  {
    content: "";
    display: block;
    margin: 5px 0;
    }

    a{
      color: none;
      background-color: none;
}

    a:focus{
      /* color: #000; */
      background-color: inherit;
    }

a :active {
  /* background-color: #000; */
}

`;


export {GlobalStyles};